import React from 'react';

import ProductItemCard from '@components/shared/items/ProductItemCard';
import { Input, Form } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Return Order Items Form Component
 * Refactored to use shared ProductItemCard.
 *
 * @param {Object} props
 * @param {Array} props.fields - Form.List fields
 * @param {Function} props.add - Form.List add function
 * @param {Function} props.remove - Form.List remove function
 * @param {Object} props.form - Antd form instance
 * @param {Function} props.fetchProducts - Product search function
 * @param {Function} props.fetchInventoryTypes - Inventory type search function
 */
const ReturnOrderItemsForm = ({
  fields,
  add,
  remove,
  form,
  productService,
  fetchInventoryTypes,
  inventoryAttributeDefinitions = [],
  role = 'admin'
}) => {
  const { t } = useTranslation();

  const renderExtraFields = (name, restField) => (
    <Form.Item
      {...restField}
      label={t('models.return_order_item.note')}
      name={[name, 'note']}
      style={{ marginTop: 8 }}
    >
      <Input placeholder={t('common.placeholder.enter_note')} />
    </Form.Item>
  );

  return (
    <div>
      {fields && fields.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <span style={{ color: '#666' }}>
            {t('shared.return_orders.form.total_items', { count: fields.length })}
          </span>
        </div>
      )}

      {fields.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '40px',
          color: '#999',
          border: '1px dashed #d9d9d9',
          borderRadius: '4px'
        }}>
          {t('shared.return_orders.form.no_items')}
        </div>
      ) : (
        fields.map(({ key, name, ...restField }) => (
          <ProductItemCard
            key={key}
            restField={restField}
            name={name}
            form={form}
            onRemove={remove}
            searchProductsService={productService}
            fetchInventoryTypes={fetchInventoryTypes}
            attributeDefinitions={inventoryAttributeDefinitions}
            renderExtraFields={renderExtraFields}
            listName="return_order_items_attributes"
            role={role}
            inventoryAttributesOptional
          />
        ))
      )}
    </div>
  );
};

export default ReturnOrderItemsForm;
